// /assets/smp-favourites.js
(function () {
  var STORAGE_KEY = 'smp_favourites_v1';

  function getFavourites() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function saveFavourites(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      // ignore quota errors etc.
    }
  }

  function toggleFavourite(handle) {
    var favs = getFavourites();
    var idx = favs.indexOf(handle);
    if (idx > -1) {
      favs.splice(idx, 1);
    } else {
      favs.push(handle);
    }
    saveFavourites(favs);
    document.dispatchEvent(new CustomEvent('smp:favourites-updated', { detail: favs }));
  }

  function updateButtons() {
    var favs = getFavourites();
    var buttons = document.querySelectorAll('[data-smp-favourite]');
    buttons.forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      var active = favs.indexOf(handle) > -1;
      btn.classList.toggle('smp-fav--active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute(
        'title',
        active ? 'Remove from favourites' : 'Save to favourites'
      );
    });
  }

  // Click handler for any favourites button
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-smp-favourite]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    toggleFavourite(handle);
    updateButtons();
  });

  // Update on page load
  document.addEventListener('DOMContentLoaded', updateButtons);
  // And on any custom updates (optional future use)
  document.addEventListener('smp:favourites-updated', updateButtons);
})();
